<template>
  <div class="user-box">
    <v-container class="box" fill-height>
      <v-row class="mb-6" justify="center" align="center">
        <v-col lg="7" md="7">
          <v-card class="mx-auto" style="min-width: 30%">
            <v-list-item style="background-color: #141824">
              <v-list-item-content>
                <v-list-item-title class="headline" style="color: #ffb600"
                  >จัดการบัญชีผู้ใช้</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <v-card-text style="padding-bottom: 0px">
              <v-data-table
                :headers="headers"
                :items="datasets"
                hide-default-footer
                height="550px"
                :items-per-page="1000"
              >
                <template v-slot:top>
                  <v-toolbar flat>
                    <v-toolbar-title>บัญชีผู้ใช้</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="ค้นหา"
                      single-line
                      hide-details
                    ></v-text-field>
                    <v-spacer></v-spacer>
                    <v-dialog v-model="dialog" persistent max-width="500px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="success"
                          dark
                          class="mb-2"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon light style="color: #fff"
                            >mdi-plus-circle</v-icon
                          >
                        </v-btn>
                      </template>
                      <v-card>
                        <v-card-title
                          style="background-color: #141824; color: #ffb600"
                        >
                          <span class="headline">{{ formTitle }}</span>
                        </v-card-title>
                        <v-card-text>
                          <v-form v-model="valid">
                            <v-container>
                              <v-row>
                                <!-- input ui -->
                                <v-col cols="12" sm="12" md="12">
                                  <v-autocomplete
                                    prepend-icon="mdi-domain"
                                    v-model="editedItem.company_name"
                                    :items="companys"
                                    item-text="fullname"
                                    item-value="username"
                                    hide-details="auto"
                                    outlined
                                    dense
                                    chips
                                    small-chips
                                    label="บริษัท/ห้างหุ้นส่วน"
                                    :rules="rules.company_name"
                                  >
                                    <template v-slot:selection="data">
                                      <v-chip small class="chip--select-multi">
                                        {{ data.item.fullname }}
                                      </v-chip>
                                    </template>
                                    <template v-slot:item="data">
                                      <template>
                                        <v-list-item-content
                                          v-text="data.item.fullname"
                                        ></v-list-item-content>
                                      </template>
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                  <v-text-field
                                    outlined
                                    dense
                                    prepend-icon="mdi-key-variant"
                                    hide-details="auto"
                                    v-model="editedItem.line_token"
                                    :rules="rules.token"
                                    label="Line Token"
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                  <v-autocomplete
                                    v-model="editedItem.province"
                                    :items="provinces"
                                    hide-details="auto"
                                    prepend-icon="mdi-clipboard-check-multiple"
                                    color="blue-grey lighten-2"
                                    outlined
                                    :rules="rules.province"
                                    dense
                                    chips
                                    small-chips
                                    label="จังหวัด"
                                    item-text="name_th"
                                    item-value="id"
                                    multiple
                                  >
                                    <template v-slot:selection="data">
                                      <v-chip
                                        close
                                        small
                                        class="chip--select-multi"
                                        @click:close="removeProvince(data.item)"
                                      >
                                        {{ data.item.name_th }}
                                      </v-chip>
                                    </template>
                                    <template v-slot:item="data">
                                      <template
                                        v-if="typeof data.item !== 'object'"
                                      >
                                        <v-list-item-content
                                          v-text="data.item"
                                        ></v-list-item-content>
                                      </template>
                                      <template v-else>
                                        <v-list-item-content
                                          v-html="data.item.name_th"
                                        ></v-list-item-content>
                                      </template>
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                  <v-autocomplete
                                    prepend-icon="mdi-clipboard-check-multiple"
                                    v-model="editedItem.type_job"
                                    :items="typeworks"
                                    item-text="job_type_name"
                                    item-value="job_type_id"
                                    hide-details="auto"
                                    outlined
                                    dense
                                    chips
                                    small-chips
                                    label="ประเภทงาน"
                                    multiple
                                    :rules="rules.typework"
                                  >
                                    <template v-slot:selection="data">
                                      <v-chip
                                        close
                                        small
                                        class="chip--select-multi"
                                        @click:close="removeType(data.item)"
                                      >
                                        {{ data.item.job_type_name }}
                                      </v-chip>
                                    </template>
                                    <template v-slot:item="data">
                                      <template>
                                        <v-list-item-content
                                          v-text="data.item.job_type_name"
                                        ></v-list-item-content>
                                      </template>
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                                <v-col cols="6" sm="6" md="6">
                                  <v-switch
                                    v-model="editedItem.ads_status"
                                    label="โฆษณา"
                                    color="success darken-3"
                                    false-value="1"
                                    true-value="0"
                                    hide-details
                                    dense
                                  ></v-switch>
                                </v-col>
                                <v-col cols="6" sm="6" md="6">
                                  <v-switch
                                    v-model="editedItem.enable"
                                    label="เเจ้งเตือน"
                                    color="success darken-3"
                                    false-value="1"
                                    true-value="0"
                                    dense
                                    hide-details
                                  ></v-switch>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-form>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            small
                            :disabled="!valid"
                            color="success darken-1"
                            @click="saveItemComfirm()"
                          >
                            บันทึก
                          </v-btn>
                          <v-btn small color="error" text @click="close()">
                            ยกเลิก
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                    <v-dialog v-model="saveDialog" persistent max-width="350px">
                      <v-card>
                        <v-card-title class="headline"
                          >ยืนยันการทำรายการหรือไม่?
                        </v-card-title>
                        <v-card-text></v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="success darken-1" small @click="save()"
                            >ยืนยัน</v-btn
                          >
                          <v-btn
                            small
                            color="error darken-1"
                            text
                            @click="closeSaveConfirm()"
                            >ยกเลิก</v-btn
                          >

                          <v-spacer></v-spacer>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-toolbar>
                </template>
                <template v-slot:item="{ item }">
                  <!-- table -->
                  <tr>
                    <td class="text-left">{{ item.company_name }}</td>
                    <td class="text-left">{{ item.line_token }}</td>
                    <td
                      class="text-center"
                      style="color: green; font-weight: bold"
                      v-if="item.ads_status === '0'"
                    >
                      <v-icon small color="success"> mdi-check-bold </v-icon>
                    </td>
                    <td
                      class="text-center"
                      style="color: red; font-weight: bold"
                      v-else
                    >
                      <v-icon small color="error"> mdi-close-thick </v-icon>
                    </td>
                    <td
                      class="text-center"
                      style="color: green; font-weight: bold"
                      v-if="item.enable === '0'"
                    >
                      <v-icon small color="success"> mdi-check-bold </v-icon>
                    </td>
                    <td
                      class="text-center"
                      style="color: red; font-weight: bold"
                      v-else
                    >
                      <v-icon small color="error"> mdi-close-thick </v-icon>
                    </td>
                    <td class="text-center">
                      <v-icon
                        class="mr-2"
                        color="warning"
                        @click="editItem(item)"
                      >
                        mdi-pencil
                      </v-icon>
                    </td>
                  </tr>
                </template>
                <template v-slot:no-data> พบ บัญชีผู้ใช้ 0 รายการ </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "adduser",
  data: () => ({
    valid: false,
    companys: [],
    typeworks: [],
    provinces: [],
    search: "",
    headers: [
      {
        text: "บริษัท/ห้างหุ้นส่วน",
        align: "start",
        sortable: false,
        value: "company_name",
      },
      {
        text: "Line Token Code",
        align: "start",
        sortable: false,
        value: "line_token",
      },
      {
        text: "โฆษณา",
        align: "center",
        sortable: false,
        value: "ads_status",
      },
      {
        text: "เเจ้งเตือน",
        align: "center",
        sortable: false,
        value: "enable",
      },
      {
        text: "แก้ไข",
        align: "center",
        sortable: false,
        value: "actions",
      },
    ],
    datasets: [],
    dialog: false,
    saveDialog: false,
    editedIndex: -1,
    editedItem: {
      id: null,
      type_job: null,
      province: null,
      line_token: null,
      company_name: null,
      ads_status: "0",
      enable: "0",
      created_by: null,
      module: null,
      version: null,
      browser: null,
      ipaddress: null,
    },
    rules: {
      typework: [(v) => !!v || "กรุณาเลือกประเภทงาน"],
      province: [(v) => !!v || "กรุณาเลือกจังหวัด"],
      token: [(v) => !!v || "กรุณากรอก Token"],
      company_name: [(v) => !!v || "กรุณากรอกชื่อบริษัท/ห้างหุ้นส่วน"],
    },
  }),
};
</script>

<style></style>
